/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiGroupReservationFromJSON, StreemApiGroupReservationToJSON, } from './';
export function StreemApiEventsGroupReservationUpdatedFromJSON(json) {
    return StreemApiEventsGroupReservationUpdatedFromJSONTyped(json, false);
}
export function StreemApiEventsGroupReservationUpdatedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'previousGroupReservation': !exists(json, 'previous_group_reservation') ? undefined : StreemApiGroupReservationFromJSON(json['previous_group_reservation']),
        'updatedGroupReservation': !exists(json, 'updated_group_reservation') ? undefined : StreemApiGroupReservationFromJSON(json['updated_group_reservation']),
    };
}
export function StreemApiEventsGroupReservationUpdatedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'previous_group_reservation': StreemApiGroupReservationToJSON(value.previousGroupReservation),
        'updated_group_reservation': StreemApiGroupReservationToJSON(value.updatedGroupReservation),
    };
}
//# sourceMappingURL=StreemApiEventsGroupReservationUpdated.js.map